export default "__VITE_ASSET__DlNwy8Jw__"